/** Defaults applied when a tenant is created from platform admin. */
export const tenantDefaults = {
  listOnPlatform: false,
  allowGuestCart: false,
  allowGuestOrders: false,
};
